/**
 * @Description: 科三考场视频列表页面
 * @author ZhanFuzheng
 * @date 2022/11/07 11:29:01
*/
<template>
    <div :class="['wrapper']">
        <!--头部-->
        <div class="header">
            <div class="header-left" @click="goBack"><img src="@/assets/public/icon_back.png" alt=""/></div>
            <div class="header-main">考场视频</div>
            <div class="header-right"></div>
        </div>

        <!--分享框架-->
        <div class="video">
            <img class="banner" src="@/assets/examVideoV2/picture_kcsplby01@2x.png">
            <div class="video-wrap">
                <div class="video-head">
                    <img src="@/assets/examVideoV2/icon_bf@2x.png">
                    <h4>{{videoInfo.examPlaceName}}</h4>
                    <span class="count">共{{videoInfo.routeCount}}条路线</span>
                </div>
                <div class="video-content">
                    <div v-for="item in videoInfo.videoList" :key="item.id" class="video-item" @click="goExamDetail(item)">
                        <div class="video-item__thumbnail">
                            <img :src="item.coverUrl" />
                            <div class="video-item__mask">
                                <div class="place-name">{{item.examPlaceName}}</div>
                                <div class="name">{{item.name}}</div>
                                <div class="timer">{{formatSeconds(item.duration)}}</div>
                                <img class="player" src="@/assets/examVideoV2/icon_playbig@2x.png" alt="">
                                <img v-if="item.vipFlag" class="vip" src="@/assets/examVideoV2/icon_vipbig@2x.png" alt="">
                            </div>
                        </div>
                        <div class="video-item__name">{{item.name}}</div>
                        <div class="video-item__operate">
                            <span><van-icon class="icon" name="eye-o" />{{item.clickRate}}</span>
                            <span><van-icon class="icon" name="good-job-o" />{{item.likeNum}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--底部-->
        <examVideoPay v-if="!dataLoading && !isOpenVip" :loading="loading" title="科三考场视频VIP" :payData="examVideoData" :examPlace="videoInfo" :carType="Number(this.carType)" @toggleExamPlace="goBack" @submit="submit" />
        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>
    </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Icon } from 'vant'
import examVideoPay from '@/components/goodsPay/examVideo'
export default {
    name: 'examThreeVideoV2Video',
    components: {
        ctlDialog: dialog,
        [Icon.name]: Icon,
        examVideoPay
    },
    data () {
        return {
            examVideoData: {},
            videoInfo: {},
            dataLoading: false,
            loading: false,
            userInfo: {},
            carType: '',
            goodsCode: '',
            H5: false,
            version: '',
            appType: '',
            shareData: {},
            headVisible: 1,
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            vipData: {},
            isOpenVip: false
        }
    },
    methods: {
        init () {
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            this.cityCode = this.$route.query.cityCode || this.$jsBridge.callBackHandler('passRegionCodeData')

            // app埋点
            this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_ervip_detail_visit', map: JSON.stringify({ subject: 3 }) })

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置考场id
            this.examPlaceBatchId = this.$route.query.examPlaceBatchId

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || '考场视频VIP'
            // 内容
            let content = '真实考场视频拍摄，让你足不出户全方位看考场~'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'examroomVideo-detail'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}&cityCode=${this.cityCode}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/kskcspVIP_3.png'
            }

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')
            this.userInfo = userInfo ? JSON.parse(userInfo) : {}
            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')
            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }
            // 重新设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')
            this.getList()
        },
        // 获取vip数据
        getVipData () {
            return this.$api.getVipGoodsSettingInfo({
                subject: '3',
                goodsCode: this.goodsCode,
                version: this.version,
                examPlaceBatchId: this.examPlaceBatchId
            }).then(res => {
                if (res.status && res.result) {
                    // 设置vip数据
                    this.vipData = res.result
                    // 设置科三考场视频数据
                    this.examVideoData = res.result
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 返回
        goBack () {
            if (window.history.state && window.history.state.key) {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        getList () {
            this.dataLoading = true
            const { examPlaceId, examPlaceBatchId } = this.$route.query
            this.$api.getRouteVideoList({
                subject: 3,
                examPlaceId,
                examPlaceBatchId
            }).then(res => {
                if (res.status) {
                    this.videoInfo = res.result
                    let isOpenVip = this.videoInfo.vipFlag
                    this.examPlaceBatchId = this.videoInfo.examPlaceBatchId
                    if (this.videoInfo.disableMessage) {
                        isOpenVip = true
                        this.messageDialog = {
                            visible: true,
                            rightBtnName: '我知道了',
                            rightBtnMethod: () => {
                                this.messageDialog.visible = false
                            },
                            title: '提示',
                            content: this.videoInfo.disableMessage
                        }
                    }
                    this.isOpenVip = isOpenVip
                    this.getVipData()
                } else {
                    Toast(res.message)
                }
                this.dataLoading = false
            })
        },
        // 跳转考场详情
        goExamDetail (v) {
            this.$jsBridge.callBackHandler('pushVideoDetailPage', { itemJson: JSON.stringify(v), subject: 3 })
        },
        // 分钟计算
        formatSeconds (s) {
            s = parseInt(s)
            // 计算分钟
            // 算法：将秒数除以60，然后下舍入，既得到分钟数
            let h
            h = Math.floor(s / 60)
            // 计算秒
            // 算法：取得秒%60的余数，既得到秒数
            s = s % 60
            // 将变量转换为字符串
            h += ''
            s += ''
            // 如果只有一位数，前面增加一个0
            h = (h.length === 1) ? '0' + h : h
            s = (s.length === 1) ? '0' + s : s
            return h + ':' + s
        },
        // 处理错误码
        handleErrorCode (v) {
            if (v.code === '666') {
                Toast.fail(v.message)
            }
            if (v.code === '1004') {
                if (this.$jsBridge.hasNativeMethod('pushFeedBackPage')) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '遗憾放弃',
                        leftBtnName: '我要反馈',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转app意见反馈
                            this.$jsBridge.callBackHandler('pushFeedBackPage')
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                } else {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '我知道了',
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                }
            }
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // 判断是否已经购买
            if (this.isOpenVip) {
                // 开通处理
                this.openSuccess()
                return
            }

            this.moneyOpenModel()
        },

        // 开通成功统一处理
        openSuccess () {
            sessionStorage.setItem('vipGoodsExamPlaceBatchId', this.videoInfo.examPlaceBatchId)

            // 回调App开通成功
            this.$jsBridge.callBackHandler('openSuccess', { vipVideoType: '3', goodsCode: this.goodsCode })
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }
            // 请求数据
            let postData = {
                currentUserId: this.userInfo.userId,
                cityCode: this.cityCode,
                goodsCode: this.goodsCode,
                subject: '3',
                version: this.version,
                examPlaceBatchId: this.videoInfo.examPlaceBatchId
            }
            this.loading = true
            this.$api.vipGoodsPay(postData).then(res => {
                this.loading = false
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 兼容ios设置类型
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 3 })

                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', { orderId: res.result, productId: this.examVideoData.productId, goodsCode: this.goodsCode })
                        return
                    }

                    // 跳转付款页
                    this.$router.push({ name: 'pay',
                        query: {
                            payId: res.result,
                            goodsCode: this.goodsCode,
                            money: this.examVideoData.payConPrice > 0 ? this.examVideoData.payConPrice : this.examVideoData.payOrigPrice,
                            type: '5',
                            headShow: this.headVisible
                        }
                    })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                            this.$router.push({ name: 'examThreeVideoOrderDetail', query: { id: res.result, headShow: this.headVisible, goodsCode: this.goodsCode } })
                        },
                        title: '',
                        content: '您有科目三考场视频VIP订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                }
                // 处理通用错误码
                this.handleErrorCode(res)
            })
        },
        // 支付回调
        payCallback (v) {
            // 开通成功
            if (String(v) === '1') {
                sessionStorage.setItem('vipGoodsExamPlaceBatchId', this.videoInfo.examPlaceBatchId)

                this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.goodsCode })
            }
        }
    },
    created () {
        this.goodsCode = '105'

        this.init()
        this.getList()
    }
}
</script>

<style lang="scss" scoped>
    .wrapper{
        background: #FEECDE;
        .header{
            position: sticky;
            top: 0;
            z-index: 9;
            background: #ffffff;
            display: flex;
            align-items: center;
            padding: 13px 10px;
            .header-left,.header-right{
                display: flex;
                align-items: center;
                width: 100px;
                img{
                    width: 24px;
                }
            }
            .header-right{
                justify-content: end;
                img+img{
                    margin: 0 0 0 13px;
                }
            }
            .header-main{
                text-align: center;
                flex: 1;
                font-size: 18px;
                font-weight: 600;
                color: #333333;
            }
        }
    }
    .banner{
        width: 100%;
        vertical-align: middle;
    }
    .video{
        * {
            box-sizing: border-box;
        }
    }
    .video-wrap{
        padding: 20px 10px;
    }
    .video-head{
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        line-height: 1;
        img{
            margin-right: 4px;
            width: 15px;
            height: 15px;
            vertical-align: middle;
        }
        h4{
            flex: 1;
            color: #333333;
            font-size: 20px;
            font-weight: 600;
        }
        .count{
            font-size: 13px;
            color: #FF6F04;
        }
    }
    .video-item{
        margin-bottom: 20px;
        &:last-child{
            margin-bottom: 0;
        }
        &__thumbnail {
            position: relative;
            width: 355px;
            height: 229px;
            border-radius: 11px;
            overflow: hidden;
            &>img{
                width: 100%;
                height: 100%;
            }
        }
        &__mask{
            position: absolute;
            background: rgba(0,0,0,0.5);
            top: 0;
            left:0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1;
            color:rgb(204,204,204);
            .place-name{
                font-size: 34px;
            }
            .name{
                margin-top: 25px;
                font-size: 31px;
                font-weight: 600;
            }
            .timer{
                position: absolute;
                right: 12px;
                bottom: 14px;
                color:#fff;
                font-size: 14px;
                line-height: 1;
            }
            .player{
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 48px;
                height: 48px;
            }
            .vip{
                position: absolute;
                top: 0;
                right: 12px;
                width: 50px;
                height: 22px;
            }
        }
        &__name{
            margin-top: 20px;
            color: #333333;
            font-size: 15px;
            font-weight: 400;
            line-height: 1;
        }
        &__operate{
            margin-top: 20px;
            display: flex;
            color: #999999;
            font-size: 13px;
            line-height: 1;
            span{
                display: flex;
                align-items: center;
                margin-right: 20px;
                .icon{
                    margin-right: 6px;
                }
            }
        }
    }
</style>
